import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 32px;
  background: linear-gradient(135deg, #abddffff 0%, #ffffff 50%, #abddffff 100%);
  text-align: center;
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  background-color: #dbeafe;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  font-size: 40px;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 8px;
  line-height: 1.2;
`;

const Year = styled.span`
  display: block;
  color: #2563eb;
  margin-top: 8px;
  font-size: 40px;
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: #4b5563;
  margin-top: 16px;
  max-width: 400px;
  line-height: 1.5;
`;

const HeroSlide = () => {
  return (
    <Container>
      <IconWrapper>✨</IconWrapper>
      <Title>
        Tu Recap Financiero
        <Year>2025</Year>
      </Title>
      <Subtitle>
        Un año de progreso, aprendizaje y crecimiento financiero.
        Descubre tus momentos clave.
      </Subtitle>
    </Container>
  );
};

export default HeroSlide;
